export default __webpack_public_path__ + "e2b9cd40a046efd1e7f16892e9776160.png";